import {useQuery} from '@tanstack/react-query'
import {getGoalsForCreator} from '../services/goal.http'
import {QUERY_KEYS} from './keys'

export const useGetGoalsForCreator = () => {
    const query = useQuery({
        queryKey: [QUERY_KEYS.goalsForCreator],
        queryFn: getGoalsForCreator
    })
    return {...query, data: query.data || []}
}
